var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFolderOpen = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.885,
    height: 16.674,
    viewBox: "0 0 21.885 16.674",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Folder_Open",
    "data-name": "Folder Open",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13223",
    "data-name": "Path 13223",
    d: "M26.279,22H11.144a1.563,1.563,0,0,0-1.463,1.013L7.068,29.971a1.042,1.042,0,0,0,.975,1.408H23.178a1.563,1.563,0,0,0,1.463-1.013l2.611-6.952A1.042,1.042,0,0,0,26.279,22Z",
    transform: "translate(-5.437 -14.705)",
    fill: "#8c919a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13224",
    "data-name": "Path 13224",
    d: "M4.167,22.716,4.8,21.027l.561-1.494L6.78,15.759a3.141,3.141,0,0,1,2.927-2.028H23.8V12.95a2.348,2.348,0,0,0-2.345-2.345H14.444l-2.33-1.942A2.87,2.87,0,0,0,10.28,8H6.345A2.348,2.348,0,0,0,4,10.345V22.33a2.3,2.3,0,0,0,.095.623C4.116,22.873,4.138,22.794,4.167,22.716Z",
    transform: "translate(-4 -8)",
    fill: "#8c919a"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFolderOpen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/folder-open.41fc8b712dc27af62c4ea2efb0ee0683.svg";